import React, { useEffect, useState } from 'react';
import useAutomations from '../hooks/automationhooks/useAutomations';
import { useParams } from 'react-router-dom';
import { Box, Button, InputLabel, TextField, Typography } from '@mui/material';

export default function InforUTokenCreationPage() {
    const { brandId } = useParams();
    const {
        isLoading,
        userData,
        handleGetInforUToken,
        handleGetUserData,
        handleCreateInforUToken,
    } = useAutomations();

    const [response, setResponse] = useState(null);
    const [apiToken, setApiToken] = useState('');
    const [inforuUser, setUser] = useState('');
    const [isSubmitting, setSubmitting] = useState(false);

    useEffect(() => {
        const init = async () => {
            try {
                const res = await handleGetInforUToken(brandId);
                setResponse(res);
            } catch (e) {
                console.warn('Token fetch failed', e);
            }
            handleGetUserData();
        };

        init();
    }, []);

    const handleSubmit = async () => {
        if (!apiToken.trim() || !inforuUser.trim() || !userData?.userId) return;

        setSubmitting(true);
        try {
            const newToken = await handleCreateInforUToken(
                brandId,
                userData.userId,
                inforuUser.trim(),
                apiToken.trim()
            );
            setResponse({ data: newToken });         
        } catch (err) {
            console.error('Error creating token:', err);
        } finally {
            setSubmitting(false);
        }
    };

    const formValid = apiToken.trim() !== '' && inforuUser.trim() !== '';

    return (
        <>
            {isLoading && <div>Loading...</div>}

            {userData == null && !isLoading && <div>No user data found</div>}

            {!isLoading && response?.data && userData != null ? (
                <div>Token already exists for this brand</div>
            ) : (
                <>
                    <Box>
                        <Box sx={{ mb: 2, mt: 2, ml: 2 }}>
                            <Typography color="companyBlue" variant="h6" gutterBottom>
                                InforU Token Saver
                            </Typography>
                        </Box>
                    </Box>

                    <Box
                        component="form"
                        noValidate
                        autoComplete="off"
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleSubmit();
                        }}
                        sx={{
                            bgcolor: 'background.paper',
                            p: 3,
                            borderRadius: 1,
                            mb: 2,
                            height: '100%',
                        }}
                    >
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <Box>
                                <InputLabel>InforU API Token</InputLabel>
                                <TextField
                                    name="apiToken"
                                    value={apiToken}
                                    onChange={(e) => setApiToken(e.target.value)}
                                    fullWidth
                                />
                            </Box>

                            <Box>
                                <InputLabel>InforU Username</InputLabel>
                                <TextField
                                    name="inforuUser"
                                    value={inforuUser}
                                    onChange={(e) => setUser(e.target.value)}
                                    fullWidth
                                />
                            </Box>

                            <Button
                                color="companyBlue"
                                aria-label="submit"
                                variant="contained"
                                disabled={!formValid || isSubmitting}
                                sx={{
                                    mt: 2,
                                    borderRadius: '50px',
                                    height: '40px',
                                    textTransform: 'none',
                                }}
                                onClick={handleSubmit}
                            >
                                <Typography color="text.primary">
                                    {isSubmitting ? 'Submitting…' : 'Submit'}
                                </Typography>
                            </Button>
                        </Box>
                    </Box>
                </>
            )}
        </>
    );
}
